// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"74d69007","574":"d47ae160","807":"de283304","818":"ac87c657","899":"1129a6b9","900":"bbec8e99","959":"1ee18304","996":"96a590f6"}[chunkId] + ".chunk.js";
};